// Whether adding this session to My Schedule should surface the "you'll need to
// save a seat later" reminder. True only for a limited-capacity session during
// the window where My Schedule is live but Save a Seat isn't open yet — once
// seat reservations open, the user can just save a seat directly, so no reminder.
//
// Pure (no Vue APIs) so it's safe in shared/ and unit-testable.
export function shouldShowSeatReminder(session, showMySchedule, showSeatReservations) {
    return session?.session_reservations === true && showMySchedule === true && showSeatReservations === false;
}
